import React from "react";
import PropTypes from "prop-types";
import { Upload, Button, Icon } from "antd";

class FileUploader extends React.Component {
    render() {
        return (
            <Upload
                fileList={this.props.fileList || []}
                multiple={this.props.multiple}
                disabled= {this.props.disabled || false}
                accept={this.props.accept}
                beforeUpload={file => {
                    this.props.onChange(file);
                    return false;
                }}
                showUploadList={this.props.showUploadList}
            >
                <div className={"d-flex"}>
                    <Button className={"mr-10"}>
                        <Icon type={"upload"} /> {this.props.btnLabel}
                    </Button>

                    {this.props.value ? (
                        <div>{this.props.value.name}</div>
                    ) : null}
                </div>
            </Upload>
        );
    }
}

FileUploader.propTypes = {
    mode: PropTypes.string,
    value: PropTypes.object,
    accept: PropTypes.string,
    onChange: PropTypes.func,
    btnLabel: PropTypes.string,
    showUploadList: PropTypes.bool,
    multiple: PropTypes.bool,
    disabled: PropTypes.bool,
    fileList: PropTypes.list
};

FileUploader.defaultProps = {
    multiple: false,
    fileList : []
};

export default FileUploader;
